import type { MigrationStrategies } from "./_types/migration-strategies";

export const SYMPTOM_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
};
